export const SAMPLES_API = 'assets/mocks/samples.json';
export const ANALYSIS_API = 'assets/mocks/analysis.json';